import { mediaGQLFields } from '../media/media.fields.js';
import { customFieldsSchemaGQLFields, } from '../network/customFieldsSchema.fields.js';
import { postTypeAuthMemberPropsGQLFields, } from '../permission/postTypeAuthMemberProps.fields.js';
import { slateGQLFields } from '../slate/slate.fields.js';
const BASIC_POST_TYPE_FIELDS = {};
const ALL_POST_TYPE_FIELDS = {
    slate: 'all',
    postFields: 'basic',
    validReplyTypes: 'basic',
    authMemberProps: 'basic',
    icon: 'basic',
};
export function postTypeGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_POST_TYPE_FIELDS;
    if (fields === 'all')
        fields = ALL_POST_TYPE_FIELDS;
    return `
    __typename
    allowedEmojis
    context
    createdAt
    forbiddenEmojis
    id
    languageTemplate
    name
    description
    nativeFieldsTemplates {
      description
      thumbnailId
      title
    }
    negativeReactions
    pluralName
    positiveReactions
    primaryReactionType
    shortContentTemplate
    singleChoiceReactions
    ${fields.slate
        ? `
        slate {
        ${slateGQLFields(fields.slate)}
      }
    `
        : ``}
    slug
    titleTemplate
    updatedAt   
    mappings {
      key
      field
      type
      title
      description
      required
      isMainContent
      isSearchable
      default
    }
    ${fields.postFields
        ? `
      postFields {
        ${customFieldsSchemaGQLFields(fields.postFields)}
      }
    `
        : ``}
    ${fields.icon
        ? `
      icon {
        ${mediaGQLFields(fields.icon)}
      }
    `
        : ``}    
    ${fields.validReplyTypes
        ? `
      validReplyTypes {
        ${postTypeGQLFields(fields.validReplyTypes)}
      }
    `
        : ``}
    ${fields.authMemberProps
        ? `
      authMemberProps {
        ${postTypeAuthMemberPropsGQLFields(fields.authMemberProps)}
      }
    `
        : ``}    
  `;
}
//# sourceMappingURL=postType.fields.js.map